export default __webpack_public_path__ + "static/media/ic_invoice_b.33b4d464.svg";